import $ from "jquery";
import select2 from "select2";

/**
 * Registers $.fn.select2.
 *
 * select2 ships a UMD wrapper. Webpack provides an AMD `define`, so it took that branch
 * and registered the plugin as a side effect of the import. Vite has no AMD, so the
 * CommonJS branch runs and only *exports* an initialiser that has to be called.
 *
 * This lives in its own module rather than in app.js because imports are evaluated before
 * the importing module's body: `lib/content/select2.js` would otherwise run — and call
 * $el.select2() — before app.js ever got to the initialiser.
 */
if (typeof select2 === "function" && !$.fn.select2) {
    select2(window);
}
